import type { FieldDeadlineStatus } from '@/modules/field/types';
import { todayIsoDateLocal } from '@/modules/field/utils/dates';

/** Prazo do RDO: em atraso quando a data do relatório é anterior a hoje. */
export function resolveFieldReportDeadlineStatus(
  reportDateIso: string | null | undefined,
): FieldDeadlineStatus {
  if (!reportDateIso) {
    return 'on_time';
  }

  return reportDateIso < todayIsoDateLocal() ? 'delayed' : 'on_time';
}
